/** Attempts to auto-detect the main product image on the current page. */
export function detectProductImage(): string | null {
  // 1. OG image meta tag
  const ogImage = document.querySelector<HTMLMetaElement>(
    'meta[property="og:image"]'
  );
  if (ogImage?.content) return ogImage.content;

  // 2. Schema.org Product JSON-LD
  const jsonLdScripts = document.querySelectorAll<HTMLScriptElement>(
    'script[type="application/ld+json"]'
  );
  for (const script of jsonLdScripts) {
    try {
      const data = JSON.parse(script.textContent || "");
      const image = extractSchemaImage(data);
      if (image) return image;
    } catch {
      // ignore invalid JSON-LD
    }
  }

  // 3. Common product image selectors
  const selectors = [
    "[data-product-image] img",
    "[data-product-image]",
    ".product-image img",
    ".product-gallery img",
    "#product-image",
    ".product__media img",
    ".product-single__photo img",
    ".woocommerce-product-gallery img",
    ".product-media img",
  ];

  for (const selector of selectors) {
    const el = document.querySelector<HTMLImageElement>(selector);
    if (el) {
      const src = el.src || el.dataset.src || el.dataset.zoom;
      if (src) return src;
    }
  }

  return null;
}

function extractSchemaImage(data: unknown): string | null {
  if (!data || typeof data !== "object") return null;

  if (Array.isArray(data)) {
    for (const item of data) {
      const result = extractSchemaImage(item);
      if (result) return result;
    }
    return null;
  }

  const obj = data as Record<string, unknown>;

  if (
    obj["@type"] === "Product" ||
    obj["@type"] === "IndividualProduct"
  ) {
    const image = obj.image;
    if (typeof image === "string") return image;
    if (Array.isArray(image) && typeof image[0] === "string") return image[0];
    if (image && typeof image === "object") {
      const imgObj = image as Record<string, unknown>;
      if (typeof imgObj.url === "string") return imgObj.url;
      if (typeof imgObj.contentUrl === "string") return imgObj.contentUrl;
    }
  }

  // Check @graph
  if (Array.isArray(obj["@graph"])) {
    return extractSchemaImage(obj["@graph"]);
  }

  return null;
}
